import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ClinicalInsights from './pages/ClinicalInsights'
import Dashboard from './pages/Dashboard'
import PatientDetail from './pages/PatientDetail'
import Analytics from './pages/Analytics'
import Login from './pages/Login'
import Layout from './components/Layout'
import { AuthProvider, useAuth } from './context/AuthContext'

/**
 * Routes shown to authenticated users. Caregivers are scoped by the backend
 * (403s on out-of-scope data); clinicians have full access.
 */
function AuthenticatedApp() {
  const { role } = useAuth()
  const isCaregiver = role === 'caregiver'

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Caregivers land on the patient list (scoped); clinicians on insights */}
        <Route
          index
          element={<Navigate to={isCaregiver ? '/dashboard' : '/clinical-insights'} replace />}
        />

        {/* Population/clinical command center - clinicians only */}
        {!isCaregiver && (
          <Route path="clinical-insights" element={<ClinicalInsights />} />
        )}

        {/* Patient list (filtered to scope server-side for caregivers) */}
        <Route path="dashboard" element={<Dashboard />} />

        {/* Patient Detail Page */}
        <Route path="patients/:patientId" element={<PatientDetail />} />

        {/* Population analytics - clinicians only */}
        {!isCaregiver && <Route path="analytics" element={<Analytics />} />}

        {/* Catch-all */}
        <Route
          path="*"
          element={<Navigate to={isCaregiver ? '/dashboard' : '/clinical-insights'} replace />}
        />
      </Route>
    </Routes>
  )
}

function AppGate() {
  const { isAuthenticated, bootstrapping } = useAuth()

  if (bootstrapping) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading…</div>
  }

  if (!isAuthenticated) {
    return <Login />
  }

  return <AuthenticatedApp />
}

function App() {
  return (
    <AuthProvider>
      <AppGate />
    </AuthProvider>
  )
}

export default App
